// extracted by mini-css-extract-plugin
export default {"gateInstruction":"a4903409e98e70b4"};